<template>
    <div class="echarts-bar-wrapper" :style="{ height: height + 'px' }">
        <v-chart :options="chartOptions" autoresize ref="chart" />
    </div>
</template>
<script>
export default {
    name: "EChartsBar",
    props: {
        labels: { type: Array, default: () => [] },
        datasets: { type: Array, default: () => [] },
        options: { type: Object, default: () => ({}) },
        height: { type: Number, default: 300 },
        stacked: { type: Boolean, default: false },
    },
    computed: {
        chartOptions() {
            const series = this.datasets.map((ds) => ({
                name: ds.label || "",
                type: "bar",
                stack: this.stacked ? "total" : undefined,
                data: ds.data || [],
                barMaxWidth: 40,
                itemStyle: {
                    color: ds.backgroundColor || "#3b82f6",
                    borderColor: ds.borderColor || "transparent",
                    borderWidth: ds.borderWidth || 0,
                    borderRadius: ds.borderRadius || [3, 3, 0, 0],
                },
            }));

            return {
                tooltip: {
                    trigger: "axis",
                    axisPointer: { type: "shadow" },
                    backgroundColor: "rgba(0,0,0,0.8)",
                    textStyle: { color: "#fff", fontSize: 12 },
                    padding: 12,
                    borderRadius: 8,
                },
                legend: {
                    top: 0,
                    textStyle: { fontSize: 12 },
                    data: this.datasets.map((ds) => ds.label || ""),
                },
                grid: {
                    left: "3%",
                    right: "4%",
                    bottom: "3%",
                    containLabel: true,
                },
                xAxis: {
                    type: "category",
                    data: this.labels,
                    axisLine: { lineStyle: { color: "#e5e7eb" } },
                    axisLabel: { fontSize: 11, color: "#6b7280" },
                },
                yAxis: {
                    type: "value",
                    axisLine: { show: false },
                    splitLine: { lineStyle: { color: "rgba(0,0,0,0.06)" } },
                    axisLabel: { fontSize: 11, color: "#6b7280" },
                },
                series,
                ...this.options,
            };
        },
    },
};
</script>
<style scoped>
.echarts-bar-wrapper {
    position: relative;
    width: 100%;
}
.echarts-bar-wrapper .echarts {
    width: 100% !important;
    height: 100% !important;
}
</style>
